import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DataGrid, jaJP } from "@mui/x-data-grid";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import { useHistory, useLocation } from "react-router";
import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";
import { GetAttendanceList, DeleteAttendance, PartySet } from "~slices/Party";
import { getLocalStorage } from "~/stores/Information";

export default function MemberList(props) {
    const { member_list } = props;

    const search = useLocation().search;
    const query = new URLSearchParams(search);
    const party_id = query.get("party_id");

    const history = useHistory();
    const dispatch = useDispatch();
    const party_state = useSelector((state) => state.Party);
    const member_list_total = party_state.member_list_total;
    const informationState = useSelector((state) => state.Information);
    const [businessName, setBusinessName] = useState("");
    const [page, setPage] = useState(0);

    const limit = 50;
    const afterDeadline = new Date(`${party_state.attendance_deadline_date} 16:00:00`) < new Date();

    useEffect(() => {
        //ログインしていないならログイン画面へ
        if(!getLocalStorage("organizer"))
        {
            history.push(`/Login`);
            return;
        }

        if(informationState["organizer"]["user_login"] === true)
        {
            if (!party_id) {
                history.push(`/PartyList`);
            }
            
            dispatch(GetAttendanceList({ party_id: party_id, page: 1, criteria_limit: limit }));
        }
    }, [informationState]);

    // ページ変更
    const handlePageChange = (newPage) => {
        dispatch(
            GetAttendanceList({
                party_id: party_id,
                business_name: businessName,
                page: newPage + 1,
                criteria_limit: limit,
            })
        ).then((data) => {
            setPage(data.payload.page - 1);
        });
    };

    // 業務上氏名値変更
    const handleBlurBusinessName = (e) => {
        setBusinessName(e.target.value);
    };

    // 検索ボタン押下
    const HandleSerch = (e) => {
        e.preventDefault();

        const elm = e.target.elements;
        dispatch(
            GetAttendanceList({
                party_id: party_id,
                business_name: elm.business_name.value,
                page: 1,
                criteria_limit: limit,
            })
        );
        setPage(0);
        setBusinessName(elm.business_name.value);
    };

    const AttendanceLabel = (attendance) => {
        let status;
        let color = "default";
        switch (attendance) {
            case "1":
                color = "info";
                status = "参加";
                break;
            case "2":
                color = "error";
                status = "キャンセル";
                break;
            default:
                status = "不明";
                break;
        }
        return <Chip label={status} color={color} sx={{ ml: 2, minWidth: "4rem" }} />;
    };

    const columns = [
        { field: "attendance_id", headerName: "参加ID", minWidth: 200, flex: 1, hide: true },
        {
            field: "dispatched_flag",
            headerName: "ステータス",
            width: 130,
            align: "center",
            valueGetter: (params) => AttendanceLabel(params.row?.attendance),
            renderCell: (params) => <>{AttendanceLabel(params.row?.attendance)}</>,
        },
        { field: "business_name", headerName: "業務上氏名", flex: 1, maxWidth: 250 },
        { field: "email_address", headerName: "メールアドレス", flex: 1 },
        {
            field: "",
            headerName: "",
            sortable: false,
            width: 100,
            renderCell: (params) => (
                <Button 
                    variant="contained" 
                    color="error" 
                    onClick={() => HandleDelete(params.row.attendance_id)}
                    disabled={afterDeadline}
                >
                    削除
                </Button>
            ),
        },
    ];

    const HandleDelete = (attendance_id) => {
        const isOK = window.confirm("本当に削除しますか?");
        if (!isOK) return;

        dispatch(DeleteAttendance({attendance_id: attendance_id})).then((data) => {
            if (data.payload.result === 'OK') {
                alert("削除しました。");
                dispatch(
                    GetAttendanceList({
                        party_id: party_id,
                        business_name: businessName,
                        page: page + 1,
                        criteria_limit: limit,
                    })
                ).then((data) => {
                    setPage(data.payload.page - 1);
                });
            } else {
                alert(data.payload.message);
            }
        })
    };

    return (
        <React.Fragment>
            <Container sx={{ mb: 5 }}>
                <Grid container direction="row" justifyContent="space-between" alignItems="flex-end" sx={{ mb: 1 }}>
                    <form onSubmit={HandleSerch}>
                        <TextField size="small" label="業務上氏名" name="business_name" />

                        <Button variant="contained" color="primary" type="submit" sx={{ ml: 1 }}>
                            検索
                        </Button>
                    </form>
                    <Typography variant="h6" align="center">
                        参加：{party_state.attendance_1_count}人
                    </Typography>
                </Grid>

                <div style={{ height: 800, width: "100%" }}>
                    <DataGrid
                        getRowId={(row) => row.attendance_id}
                        rows={member_list ? member_list : []}
                        columns={columns}
                        rowCount={member_list_total}
                        pageSize={limit}
                        page={page}
                        onPageChange={handlePageChange}
                        paginationMode="server"
                        sortingMode="server"
                        rowsPerPageOptions={[limit]}
                        disableColumnMenu
                        disableSelectionOnClick
                        pagination
                        localeText={jaJP.components.MuiDataGrid.defaultProps.localeText}
                    />
                </div>
            </Container>
        </React.Fragment>
    );
}
